import { RequestState } from '@fullstory/redux-util';
import { SettingsResponse } from '@fullstory/proto/fs/api/clientapi';
import { SeatSettings } from '@fullstory/client-api/goimports/fs_api_clientapi';

enum SettingsTypes {
  FetchSettingsRequest = 'settings.fetchSettingsRequest',
  FetchSettingsSuccess = 'settings.fetchSettingsSuccess',
  FetchSettingsFailure = 'settings.fetchSettingsFailure',
  FetchTeamSettingsRequest = 'settings.fetchTeamSettingsRequest',
  FetchTeamSettingsSuccess = 'settings.fetchTeamSettingsSuccess',
  FetchTeamSettingsFailure = 'settings.fetchTeamSettingsFailure',
  FetchSeatsInvitesRequest = 'settings.fetchSeatsInvitesRequest',
  FetchSeatsInvitesSuccess = 'settings.fetchSeatsInvitesSuccess',
  FetchSeatsInvitesFailure = 'settings.fetchSeatsInvitesFailure',
  FetchGuestsRequest = 'settings.fetchGuestsRequest',
  FetchGuestsSuccess = 'settings.fetchGuestsSuccess',
  FetchGuestsFailure = 'settings.fetchGuestsFailure',
  PasswordResetRequest = 'settings.changePasswordRequest',
  PasswordResetSuccess = 'settings.changePasswordSuccess',
  PasswordResetFailure = 'settings.changePasswordFailure',
  UpdateShareEnabledRequest = 'settings.updateShareEnabledRequest',
  UpdateShareEnabledSuccess = 'settings.updateShareEnabledSuccess',
  UpdateShareEnabledFailure = 'settings.updateShareEnabledFailure',
  UpdateDomainsRequest = 'settings.updateDomainsRequest',
  UpdateDomainsSuccess = 'settings.updateDomainsDomainSuccess',
  UpdateDomainsFailure = 'settings.updateDomainsDomainFailure',
  UpdateJoinOrgSettingsRequest = 'settings.updateJoinOrgSettingsRequest',
  UpdateJoinOrgSettingsSuccess = 'settings.updateJoinOrgSettingsSuccess',
  UpdateJoinOrgSettingsFailure = 'settings.updateJoinOrgSettingsFailure',
  UpdateGoogleAuthRequest = 'settings.updateGoogleAuthRequest',
  UpdateGoogleAuthSuccess = 'settings.updateGoogleAuthSuccess',
  UpdateGoogleAuthFailure = 'settings.updateGoogleAuthFailure',
  UpdateSSOAuthRequest = 'settings.updateSSOAuthRequest',
  UpdateSSOAuthSuccess = 'settings.updateSSOAuthSuccess',
  UpdateSSOAuthFailure = 'settings.updateSSOAuthFailure',
  SendInviteRequest = 'settings.sendInviteRequest',
  SendInviteSuccess = 'settings.sendInviteSuccess',
  SendInviteFailure = 'settings.sendInviteFailure',
  SendInvitesRequest = 'settings.sendInvitesRequest',
  SendInvitesSuccess = 'settings.sendInvitesSuccess',
  SendInvitesFailure = 'settings.sendInvitesFailure',
  SendSnippetRequest = 'settings.sendSnippetRequest',
  SendSnippetSuccess = 'settings.sendSnippetSuccess',
  SendSnippetFailure = 'settings.sendSnippetFailure',
  RevokeInviteRequest = 'settings.revokeInviteRequest',
  RevokeInviteSuccess = 'settings.revokeInviteSuccess',
  RevokeInviteFailure = 'settings.revokeInviteFailure',
  UpdateSeatRequest = 'settings.updateSeatRequest',
  UpdateSeatSuccess = 'settings.updateSeatSuccess',
  UpdateSeatFailure = 'settings.updateSeatFailure',
  FetchInactivityTimeoutSettingsRequest = 'settings.fetchInactivityTimeoutSettingsRequest',
  FetchInactivityTimeoutSettingsSuccess = 'settings.fetchInactivityTimeoutSettingsSuccess',
  FetchInactivityTimeoutSettingsFailure = 'settings.fetchInactivityTimeoutSettingsFailure',
  UpdateInactivityTimeoutSettingsRequest = 'settings.updateInactivityTimeoutSettingsRequest',
  UpdateInactivityTimeoutSettingsSuccess = 'settings.updateInactivityTimeoutSettingsSuccess',
  UpdateInactivityTimeoutSettingsFailure = 'settings.updateInactivityTimeoutSettingsFailure',
  UpdateSeatSettingsStarted = 'Settings.UpdateSeatSettings.Started',
  UpdateSeatSettingsSuccess = 'Settings.UpdateSeatSettings.Success',
  UpdateSeatSettingsFailure = 'Settings.UpdateSeatSettings.Failure',
  FetchApiKeysRequest = 'settings.fetchApiKeysRequest',
  FetchApiKeysSuccess = 'settings.fetchApiKeysSuccess',
  FetchApiKeysFailure = 'settings.fetchApiKeysFailure',
  DeleteApiKeyRequest = 'settings.deleteApiKeyRequest',
  DeleteApiKeySuccess = 'settings.deleteApiKeySuccess',
  DeleteApiKeyFailure = 'settings.deleteApiKeyFailure',
  UpdateApiKeyRequest = 'settings.updateApiKeyRequest',
  UpdateApiKeySuccess = 'settings.updateApiKeySuccess',
  UpdateApiKeyFailure = 'settings.updateApiKeyFailure',
  CreateApiKeyRequest = 'settings.createApiKeyRequest',
  CreateApiKeySuccess = 'settings.sreateApiKeySuccess',
  CreateApiKeyFailure = 'settings.createApiKeyFailure',
  FetchPrivacySettingsRequest = 'settings.fetchPrivacySettingsRequest',
  FetchPrivacySettingsSuccess = 'settings.fetchPrivacySettingsSuccess',
  FetchPrivacySettingsFailure = 'settings.fetchPrivacySettingsFailure',
  UpdateDiscardIpAddrsRequest = 'settings.updateDiscardIpAddrsRequest',
  UpdateDiscardIpAddrsSuccess = 'settings.updateDiscardIpAddrsSuccess',
  UpdateDiscardIpAddrsFailure = 'settings.updateDiscardIpAddrsFailure',
  SendSnippetEmailRequest = 'settings.sendSnippetEmailRequest',
  SendSnippetEmailSuccess = 'settings.sendSnippetEmailSuccess',
  SendSnippetEmailFailure = 'settings.sendSnippetEmailFailure',
  UpdateAjaxAllowlistedReqRequest = 'settings.updateAjaxAllowlistedReqRequest',
  UpdateAjaxAllowlistedReqSuccess = 'settings.updateAjaxAllowlistedReqSuccess',
  UpdateAjaxAllowlistedReqFailure = 'settings.updateAjaxAllowlistedReqFailure',
  UpdateElementRecordingRulesRequest = 'settings.updateElementRecordingRulesRequest',
  UpdateElementRecordingRulesSuccess = 'settings.updateElementRecordingRulesSuccess',
  UpdateElementRecordingRulesFailure = 'settings.updateElementRecordingRulesFailure',
  UmbrellaSettingsRequest = 'settings.umbrellaSettings.request',
  UmbrellaSettingsSuccess = 'settings.umbrellaSettings.success',
  UmbrellaSettingsFailure = 'settings.umbrellaSettings.failure',
  UmbrellaUpdateOrgsRequest = 'settings.umbrellaUpdateOrgs.request',
  UmbrellaUpdateOrgsSuccess = 'settings.umbrellaUpdateOrgs.success',
  UmbrellaUpdateOrgsFailure = 'settings.umbrellaUpdateOrgs.failure',
  UmbrellaCreateOrgRequest = 'settings.umbrellaCreateOrg.request',
  UmbrellaCreateOrgSuccess = 'settings.umbrellaCreateOrg.success',
  UmbrellaCreateOrgFailure = 'settings.umbrellaCreateOrg.failure',
  UmbrellaUpdateMetaRequest = 'settings.umbrellaUpdateMeta.request',
  UmbrellaUpdateMetaSuccess = 'settings.umbrellaUpdateMeta.success',
  UmbrellaUpdateMetaFailure = 'settings.umbrellaUpdateMeta.failure',
  UmbrellaUpdateSeatsRequest = 'settings.umbrellaUpdateSeats.request',
  UmbrellaUpdateSeatsSuccess = 'settings.umbrellaUpdateSeats.success',
  UmbrellaUpdateSeatsFailure = 'settings.umbrellaUpdateSeats.failure',
  UmbrellaManagerRequest = 'settings.umbrellaManager.request',
  UmbrellaManagerSuccess = 'settings.umbrellaManager.success',
  UmbrellaManagerFailure = 'settings.umbrellaManager.failure',
  UmbrellaCancelOrgsRequest = 'settings.umbrellaCancelOrgs.request',
  UmbrellaCancelOrgsSuccess = 'settings.umbrellaCancelOrgs.success',
  UmbrellaCancelOrgsFailure = 'settings.umbrellaCancelOrgs.failure',
  UpdateSeatDisabledRequest = 'settings.updateSeatSettings.request',
  UpdateSeatDisabledSuccess = 'settings.updateSeatSettings.success',
  UpdateSeatDisabledFailure = 'settings.updateSeatSettings.failure',
  BatchDeleteSeatsRequest = 'settings.batchDeleteSeats.request',
  BatchDeleteSeatsSuccess = 'settings.batchDeleteSeats.success',
  BatchDeleteSeatsFailure = 'settings.batchDeleteSeats.failure',
  BatchRevokeInvitesRequest = 'settings.batchRevokeInvites.request',
  BatchRevokeInvitesSuccess = 'settings.batchRevokeInvites.success',
  BatchRevokeInvitesFailure = 'settings.batchRevokeInvites.failure',
  BatchUpdateSeatsRequest = 'settings.batchUpdateSeats.request',
  BatchUpdateSeatsSuccess = 'settings.batchUpdateSeats.success',
  BatchUpdateSeatsFailure = 'settings.batchUpdateSeats.failure',
  SendPrivacySetupEmailRequest = 'sendPrivacySetupEmail.request',
  SendPrivacySetupEmailSuccess = 'sendPrivacySetupEmail.success',
  SendPrivacySetupEmailFailure = 'sendPrivacySetupEmail.failure',
  SendUmbrellaInviteRequest = 'sendUmbrellaInvite.request',
  SendUmbrellaInviteSuccess = 'sendUmbrellaInvite.success',
  SendUmbrellaInviteFailure = 'sendUmbrellaInvite.failure',
  AnalyzeQuotaRequest = 'settings.analyzeQuotaRequest',
  AnalyzeQuotaSuccess = 'settings.analyzeQuotaSuccess',
  AnalyzeQuotaFailure = 'settings.analyzeQuotaFailure',
  GetSessionOverageConfigRequest = 'settings.getSessionOverageConfigRequest',
  GetSessionOverageConfigSuccess = 'settings.getSessionOverageConfigSuccess',
  GetSessionOverageConfigFailure = 'settings.getSessionOverageConfigFailure',
  UpdateSessionOverageConfigRequest = 'settings.updateSessionOverageConfigRequest',
  UpdateSessionOverageConfigSuccess = 'settings.updateSessionOverageConfigSuccess',
  UpdateSessionOverageConfigFailure = 'settings.updateSessionOverageConfigFailure',
  GetNotificationConfigRequest = 'settings.getNotificationConfigRequest',
  GetNotificationConfigSuccess = 'settings.getNotificationConfigSuccess',
  GetNotificationConfigFailure = 'settings.getNotificationConfigFailure',
  UpdateNotificationConfigRequest = 'settings.updateNotificationConfigRequest',
  UpdateNotificationConfigSuccess = 'settings.updateNotificationConfigSuccess',
  UpdateNotificationConfigFailure = 'settings.updateNotificationConfigFailure',
  SnoozeSessionBannerNotification = 'settings.snoozeSessionBannerNotification',
  GetCustomSeatRequestConfigRequest = 'settings.getCustomSeatRequestConfigRequest',
  GetCustomSeatRequestConfigSuccess = 'settings.getCustomSeatRequestConfigSuccess',
  GetCustomSeatRequestConfigFailure = 'settings.getCustomSeatRequestConfigFailure',
  UpdateCustomSeatRequestConfigRequest = 'settings.updateCustomSeatRequestConfigRequest',
  UpdateCustomSeatRequestConfigSuccess = 'settings.updateCustomSeatRequestConfigSuccess',
  UpdateCustomSeatRequestConfigFailure = 'settings.updateCustomSeatRequestConfigFailure',
  UpdateDismissibleWarningRequest = 'settings.updateDismissibleWarningRequest',
  UpdateDismissibleWarningSuccess = 'settings.updateDismissibleWarningSuccess',
  UpdateDismissibleWarningFailure = 'settings.updateDismissibleWarningFailure',
  BatchUpdateUsersInUmbrellaRequest = 'settings.batchUpdateUsersInUmbrellaRequest',
  BatchUpdateUsersInUmbrellaSuccess = 'settings.batchUpdateUsersInUmbrellaSuccess',
  BatchUpdateUsersInUmbrellaFailure = 'settings.batchUpdateUsersInUmbrellaFailure',
}

interface SettingsState {
  settings: RequestState<SettingsResponse>;
}

// SeatSettings is currently stored in AppContext
// Moving 'DigestFreq', 'QuoteEmailEnabled', 'WebhookNotificationsEnabled', and 'DismissedWarnings'
// to Redux
type PickSeatSettings = Pick<
  SeatSettings,
  | 'DigestFreq'
  | 'QuotaEmailEnabled'
  | 'WebhookNotificationsEnabled'
  | 'MentionEmailsEnabled'
  | 'DismissedWarnings'
  | 'OpportunitiesEmailsEnabled'
>;

export { SettingsTypes };
export type { SettingsState, PickSeatSettings as SeatSettings };
